module.exports = __webpack_public_path__ + "assets/40411e6ad74b9854017760519ad65e85.svg";